import axiosInstance from "../../axiosinstance";
import { AFRICAN_MARKETS } from "./countryCurrency";

export interface PublicBook { id: string; title: string; subtitle: string; author: string; description: string; cover_url: string | null; amazon_url: string; price_africa: number; price_other: number; }
export interface CheckoutRequest { book_id: string; country: string; email: string; }
export interface CheckoutStart { approval_url: string; order_reference: string; }
export interface CheckoutResult { status: "completed" | "pending"; order_reference: string; book_title: string; amount: number; download_url: string | null; }
export interface PendingPurchase extends CheckoutRequest { book_title: string; amount: number; order_reference: string; }
export const fetchUsdRates = async (): Promise<Record<string, number>> => {
  const response = await fetch("https://open.er-api.com/v6/latest/USD");
  if (!response.ok) throw new Error("Exchange rates are unavailable");
  const data: { result?: string; rates?: Record<string, number> } = await response.json();
  if (data.result !== "success" || !data.rates) throw new Error("Exchange rates are unavailable");
  return data.rates;
};
export const BOOK_PATH = (id: string) => `/digital-library/${id}`;
export const CHECKOUT_PATH = (id: string) => `/digital-library/${id}/checkout`;
export const RETURN_PATH = "/digital-library/checkout/return";
export const CANCEL_PATH = "/digital-library/checkout/cancelled";
// The /books listing is hidden for now; books are reached from the homepage slider
export const LIBRARY_PATH = "/";
export const SUPPORT_EMAIL = "info@chantalekabeministries.com";
export const priceFor = (book: PublicBook, country: string) => AFRICAN_MARKETS.has(country) ? book.price_africa : book.price_other;
export const fetchPublicBooks = async (): Promise<PublicBook[]> => (await axiosInstance.get("/library/books")).data;
export const fetchPublicBook = async (id: string): Promise<PublicBook> => (await axiosInstance.get(`/library/books/${encodeURIComponent(id)}`)).data;
const returnUrl = (path: string) => `${window.location.origin}${path}`;
export const startBookCheckout = async (request: CheckoutRequest, book: PublicBook): Promise<string> => {
  const { data } = await axiosInstance.post<CheckoutStart>("/library/checkout", {
    ...request, return_url: returnUrl(RETURN_PATH), cancel_url: returnUrl(CANCEL_PATH),
  });
  savePendingPurchase({ ...request, book_title: book.title, amount: priceFor(book, request.country), order_reference: data.order_reference });
  return data.approval_url;
};
export const captureBookCheckout = async (orderId: string): Promise<CheckoutResult> => {
  const { data } = await axiosInstance.post<CheckoutResult>("/library/checkout/capture", { order_id: orderId });
  if (data.download_url) data.download_url = axiosInstance.getUri({ url: data.download_url });
  return data;
};
const PENDING_KEY = "pendingBookPurchase";
export const savePendingPurchase = (purchase: PendingPurchase) => { try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(purchase)); } catch { /* Checkout completion can still be shown from the API response. */ } };
export const loadPendingPurchase = (): PendingPurchase | null => { try { const value = sessionStorage.getItem(PENDING_KEY); return value ? JSON.parse(value) as PendingPurchase : null; } catch { return null; } };
export const clearPendingPurchase = () => { try { sessionStorage.removeItem(PENDING_KEY); } catch { /* Ignore storage restrictions. */ } };
